import ApiPath from "@viz-ui/services/apiPath/apiPathService";
import { createAngularCompatibleSummaryTableService } from "@viz-ui/services/charts/chartBackendServices";
import logger from "@viz-ui/services/logger/logger";

angular
  .module("acl.visualizer.charts.backend")
  .service("SummaryTableBackendService", (queuedHttp, DataModel, AppConfig) => {
    const useMigrated = AppConfig.features && AppConfig.features.migratedSummaryTableService;

    if (useMigrated) {
      logger.log("🚀 Using migrated TypeScript SummaryTableBackendService");
      return {
        fetchJson: (tableId, filter, config) => {
          const myRecords = DataModel.filterConfig.myRecords();
          const openStatuses = DataModel.filterConfig.openStatuses();
          const raw = DataModel.toSaveViz();
          const requestParams = { raw, myRecords, openStatuses };
          const chartIndex = requestParams.raw.visualizations.findIndex(d => {
            return angular.equals(d.config.dataConfig, config);
          });

          const tsService = createAngularCompatibleSummaryTableService(queuedHttp, ApiPath);
          return tsService.fetchJson(tableId, chartIndex, requestParams);
        },
        getRepresentation: (resultData, config) => {
          const tsService = createAngularCompatibleSummaryTableService(queuedHttp, ApiPath);
          return tsService.getRepresentation(resultData);
        },
      };
    }

    logger.log("📊 Using original Angular SummaryTableBackendService");

    function url(tableId, chartIndex) {
      return ApiPath.table.getSummaryTableDataUrl(tableId) + "?chart_index=" + chartIndex;
    }

    return {
      fetchJson: (tableId, filter, config) => {
        const myRecords = DataModel.filterConfig.myRecords();
        const openStatuses = DataModel.filterConfig.openStatuses();
        const raw = DataModel.toSaveViz();
        const requestParams = { raw, myRecords, openStatuses };
        const chartIndex = requestParams.raw.visualizations.findIndex(d => {
          return angular.equals(d.config.dataConfig, config);
        });

        return queuedHttp.post(url(tableId, chartIndex), requestParams);
      },

      getRepresentation: resultData => resultData,
    };
  });
